// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useState, useEffect, useCallback } from 'react';
import { SubscriptionDTO } from '../../Types/Billing';
import SubscriptionS from '../restapi/subscriptionService';

// eslint-disable-next-line import/prefer-default-export
export const useBookitupSubscription = () => {
  const [subscription, setSubscription] = useState<SubscriptionDTO>();
  const [loading, setLoading] = useState(false);
  const { addons, status } = subscription ?? {};
  const resourceAddon = addons && addons.length > 0 ? addons[0] : null;
  const isActive = status === 'ACTIVE';

  const fetchSubscriptionDetails = useCallback(() => {
    setLoading(true);
    SubscriptionS.getSubscription()
      .then((resp) => {
        if (resp.ok) {
          resp.json().then(setSubscription);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchSubscriptionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { subscription, isActive, loading, refresh: fetchSubscriptionDetails, resourceAddon };
};
